<template>
  <div>
    <el-dialog v-model="buyFreeCourseShow" title="Tips" width="500" :show-close="false" :align-center="true">
      <template #header>
        <div class="header">
          <el-image
            class="free_course_buy_success mar_top_20"
            :src="iconPath('free_course_buy_success.png')"
          ></el-image>
        </div>
        <div class="close_icon" @click="closePopup">
          <el-icon :size="20">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content flex flexcolumn Flexalign">
        <div class="congratulation_text">
          恭喜您课程购买成功！海量知识已解锁，开启学习新征程~
        </div>
        <!-- <div class="mt-15">
          该课程包含了<span class="text_active">基础，培优，拔尖</span
          >三个不同方案，默认给您解锁的为<span class="text_active">基础方案，可根据自身学习能力前往学习中心进行方案调整。</span>
        </div> -->
        <div class="btn_box mar_top_20 flex Flexalign Flexjustify">
          <div class="btn btn_select cursor_pointer" @click="goCourseList">继续选课</div>
          <div class="btn btn_learning cursor_pointer ml-30" @click="goLearning">开始学习</div>
        </div>
        <div class="qrcode_box mar_top_20 flex flexcolumn Flexalign Flexjustify">
          <qrcode-vue :value="qrCodeValue" :size="114"></qrcode-vue>
        </div>
        <div class="follow_text mar_top_15">关注冠军智能中高考公众号</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  name: "GjkcH5BuyFreeCourse",
  components: {
    QrcodeVue,
  },

  data() {
    return {
      buyFreeCourseShow: false,
      courseId: "",
      qrCodeValue: "",
    };
  },

  mounted() {},

  methods: {
    closePopup() {
      this.buyFreeCourseShow = false;
    },
    goCourseList() {
      this.closePopup();
      this.href("/courseList");
    },
    // 去学习
    goLearning() {
      this.closePopup();
      this.href("/onlineLearning", { courseId: this.courseId });
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 430px;
  // height: 540px;
  position: relative;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.header {
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  text-align: center;

  // border-bottom: 1px solid rgba(36, 35, 36, 0.1);
  .free_course_buy_success {
    width: 80px;
    height: 80px;
  }
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}

.dialog_content {
  padding: 0 25px 20px;
  box-sizing: border-box;

  .congratulation_text {
    font-size: 18px;
    color: #333333;
    line-height: 28px;
  }

  .btn_box {
    width: 100%;

    .btn {
      width: 137px;
      height: 36px;
      border-radius: 18px;
      line-height: 36px;
      text-align: center;
    }

    .btn_select {
      border: 1px solid #13d6aa;
      color: #13d6aa;
    }

    .btn_learning {
      background: linear-gradient(90deg, #00d5c2, #00d498);
      color: #fff;
    }
  }

  .qrcode_box {
    width: 130px;
    height: 130px;
    position: relative;
    border: 1px solid #999;
    border-radius: 10px;
  }

  .follow_text {
    color: #999;
    font-size: 14px;
  }
}
</style>
